module.exports = __webpack_public_path__ + "img/chevron_circle.f9da5519.svg";